import { IDataSet } from '../Track';

export class EntryPointDataSet implements IDataSet {
    public epContext: string = undefined;
    public epCustomEntryPoint: string = undefined;
    public entryPoint: string = undefined;
    public customEntryPoint: string = undefined;
    public epSenderId: string = undefined;
    public epSenderLevel: number = undefined;
    // public epSenderDaysInGame: number = undefined;
    // public epSenderCoins: number = undefined;
    public epSenderIsPayer: number = undefined;
    public epTimestamp: number = undefined;

    public epPromoSource: string = undefined;
    public otherGameIds: string = undefined;

    public epBotMsgCategory: string = undefined;
    public epBotMsgId: string = undefined;
    // public epBotGiftId: string = undefined;

    public epChanger: number = 0;
    public epRemoveOne: number = 0;
    public epMassRemove: number = 0;
    public epJoker: number = 0;
    public epCoins: number = 0;
    public epLives: number = 0;

    public campaignAdID: string = undefined;
    public campaignAdType: string = undefined;
    public campaignAdName: string = undefined;

    public screenHeight: number = 0;
    public screenWidth: number = 0;

    public mOrigin: EntryOrigin = EntryOrigin.Organic;
    public mAdType: string = undefined;
    public mAdName: string = undefined;
    public mChannel: string = undefined;
    public mAdId: string = undefined;
    public mAdsetID: string = undefined;
    public mCampaignID: string = undefined;
    // 'a' prefix stands for Adjust
    public aTrackerToken: string = undefined;
    public aTrackerName: string = undefined;
    public aAdGroup: string = undefined;
    public aCreative: string = undefined;
    public aClickLabel: string = undefined;
    public aAdID: string = undefined;
    public aCampaignID: string = undefined;
    public aNetwork: string = undefined;
}

export enum EntryOrigin {
    Organic = 'organic',
    Marketing = 'marketing',
}
